export const IS_DEV = location.href.includes('test')
export const IS_TEST = !!(window as any).expect
export const IS_PROD = !IS_DEV && !IS_TEST

export const API_HOST = `${document.location.hostname}:4000`
export const API_URL = IS_DEV ? `https://${API_HOST}` : `https://fm.cowbell.workers.dev` //${API_HOST}`

export const IS_MOBILE = /Mobi|Android|Tablet/i.test(navigator.userAgent)
export const IS_FIREFOX = navigator.userAgent.includes('Firefox')
